import React, { Component } from 'react';
import {
  Routes,
  Route
} from "react-router-dom";
import Main from './main';
import Logout from './logout';
import Statement from './statement';
import Deposit from './deposit';
import Withdraw from './withdraw';
import Rebate from './rebate';
import DailyMission from './dailymission';
import Changepassword from './changepassword';
import instance from "./axios-instance";
import Systems from "./SystemFunction";
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import io from "socket.io-client";
import md5 from 'md5';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mainsetting: [],
      checkboxcookie: false,
      phoneNumber: "",
      balance: 0,
      mainacc: null,
      pathname: "",
      qrcode: null,
      stateregis: 1,
      checkboxacc: 0,
      loginstate: false,
      fullname: null,
      link: "",
      depositstate: 0,
      stateforget: 1,
      depositamount: 0,
      stateopterror: "",
      btnisActive: true,
      otpphone: "",
      accnumber: null,
      accnumbertxt: null,
      withdrawamount: 0,
      rankpoint: 0,
      changepassword: false,
      errortext: "",
      otpphoneforget: "",
      userrecomend: "",
      historylist: [],
      useradvice: [],
      tblnextrank: [],
      tblrankall: [],
      maxwithdrawstatus: 0,
      tblprofile: [],
      prodetail: [],
      oldpassword: "",
      linkaff: "",
      truegiftlink: "",
      proderedeem: [],
      proderedeemlist: [],
      buttoncliam: false,
      limit: null,
      rankpic: "1.jpeg",
      rankname: null,
      rankob: null,
      cashoutSet: [],
      tblPopupMenu1: [],
      tblPopupMenu2: [],
      tblPopupMenu: null,
      errorstatus: false,
      userid: null,
      username: null,
    }
    this.handleClick = this.handleClick.bind(this);
    this.forgetotpandregister = this.forgetotpandregister.bind(this);
  }

  copyCode = () => {
    navigator.clipboard
      .writeText(this.state.linkaff)
      .then(() => {
        setTimeout(function () {
        }, 3000);
      })
      .catch((err) => {});
  };

  showClockRealTime = (datestart) => {
    var months_th_mini = ["ม.ค.", "ก.พ.", "มี.ค.", "เม.ย.", "พ.ค.", "มิ.ย.", "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.", "พ.ย.", "ธ.ค."];
    var today = new Date(datestart);
    var endday = months_th_mini[today.getMonth()];
    return endday;
  }

  handleClick = async (e, price) => {
    if (price <= this.state.balance) {
      this.setState({ withdrawamount: price });
    } else {
      await Swal.fire({
        title: 'Warning!',
        text: 'ยอดถอนของท่านไม่เพียงพอในการถอน',
        icon: 'warning',
        confirmButtonText: 'ตกลง'
      })
    }
  }

  getpopup = () => {
    instance.post("/api/v1/popuplist", {
      System: Systems,
      Cat_ID: 0,
      page: 1,
      type: 1
    }).then(async (res) => {
      if (res.data.status === 200) {
        this.setState({
          tblPopupMenu1: res.data.message.tblPopupMenu1,
          tblPopupMenu: res.data.message.banklist,
          tblPopupMenu2: res.data.message.tblPopupMenu2,
        });
      }
    }).catch(async (err) => {
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
        window.location.href = '/';
      }
    });
  }

  checkpro = async (e, proid) => {
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/checkpromotion", {
      userid: Username,
      System: Systems,
      Proid: proid,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        if (res.data.type === 0) {
          this.setState({ prodetail: res.data.message.tblpromotions[0] });
        } else if (res.data.type === 1) {
          this.setState({
            proderedeem: res.data.message.tblpromotionredeems,
            proderedeemlist: res.data.message.tblpromotionredeems,
          });
        }
      } else if (res.data.status === 201) {
        this.setState({ prodetail: [] });
      } else if (res.data.status === 202) {
        await Swal.fire({
          title: 'error!',
          text: 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        return false;
      }
    }).catch(async (err) => {
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
        window.location.href = '/';
      }
    });
  }

  redeempro = async (e, proid) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/redeempromotion", {
      userid: Username,
      System: Systems,
      Proid: proid,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        document.getElementById("opendeposit").click()
      } else if (res.data.status === 201) {
        await Swal.fire({
          title: 'error!',
          text: 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        e.preventDefault();
        return false;
      } else if (res.data.status === 204) {
        await Swal.fire({
          title: 'error!',
          text: 'ท่านใช้สิทธวันนี้ครบแล้ว',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        e.preventDefault();
        return false;
      } else if (res.data.status === 202) {
        await Swal.fire({
          title: 'error!',
          text: 'ท่านใช้โปรมั่นชั่นนี้ไปแล้ว',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        e.preventDefault();
        return false;
      }
    }).catch(async (err) => {
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
        window.location.href = '/';
      }
    });
  }

  async recheccredit(evt) {
    evt.currentTarget.className += " fa-spin";
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    this.setState({
      userid: decoded.message.playerid,
      username: decoded.message.playerid,
      firstname: decoded.message.firstname,
      lastname: decoded.message.lastname,
      loginstate: true,
    });
    try {
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Function: 'recheccredit-App.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          localStorage.setItem('auth_token', res.data.token)
          this.setState({
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fullname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
          var i, tablinks;
          tablinks = document.getElementsByClassName("btn btn-link -reload-btn p-0");
          for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" fa-spin", "");
          }
        } else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      });
    } catch (ex) {}
  }

  handleClickdeposit = async (e, price) => {
    this.setState({ depositamount: price });
  }

  onChangexdep = event => {
    if (event.target !== undefined) {
      this.setState({ depositamount: event.target.value });
    }
  };

  onChangexgiftlink = event => {
    if (event.target !== undefined) {
      this.setState({ truegiftlink: event.target.value });
    }
  };

  confirmdeposittrue = async (e, num) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    if (token != null && this.state.btnisActive === true) {
      if (this.state.truegiftlink !== "") {
        this.setState({ statetrue: "โปรดรอซักครุ่กำลังดำเนินการ", btnisActive: false });
        Username = decoded.message.playerid;
        await instance.post("/api/v1/redeemtrue", {
          userid: Username,
          System: Systems,
          link: this.state.truegiftlink
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          if (res.data.status == 200) {
            this.setState({ btnisActive: true, statetrue: "โปรดใส่ลิ้งค์ ของขวัญด้านล่าง ขั้นต่ำ 10 บาท" });
            await Swal.fire({
              title: 'Success!',
              text: "เติมเงินสำเร็จจำนวน " + res.data.amountx + "  บาท ",
              icon: 'success',
              confirmButtonText: 'ตกลง'
            })
          } else if (res.data.status == 202) {
            this.setState({ btnisActive: true, statetrue: "โปรดใส่ลิ้งค์ ของขวัญด้านล่าง ขั้นต่ำ 10 บาท" });
            await Swal.fire({
              title: 'Warning!',
              text: 'ลิ้งค์ของขวัญถูกใช้งานไปแล้วไม่สามารถไช้ได้',
              icon: 'warning',
              confirmButtonText: 'ตกลง'
            })
          } else if (res.data.status == 203) {
            this.setState({ btnisActive: true, statetrue: "โปรดใส่ลิ้งค์ ของขวัญด้านล่าง ขั้นต่ำ 10 บาท" });
            await Swal.fire({
              title: 'Warning!',
              text: 'ลิงค์เติมเงิน ไม่ใช่ชื่อบัญชีของคุณ โปรดตรวจสอบ',
              icon: 'warning',
              confirmButtonText: 'ตกลง'
            })
          } else if (res.data.status == 205) {
            this.setState({ btnisActive: true, statetrue: "โปรดใส่ลิ้งค์ ของขวัญด้านล่าง ขั้นต่ำ 10 บาท" });
            await Swal.fire({
              title: 'Warning!',
              text: 'ปิดระบบเติมเงินทรู รออัพเดท',
              icon: 'warning',
              confirmButtonText: 'ตกลง'
            })
          } else {
            this.setState({ btnisActive: true, statetrue: "โปรดใส่ลิ้งค์ ของขวัญด้านล่าง ขั้นต่ำ 10 บาท" });
            await Swal.fire({
              title: 'Warning!',
              text: 'ทำรายการไม่สำเร็จหรือลิงค์ไม่สามารถใช้ได้ ',
              icon: 'warning',
              confirmButtonText: 'ตกลง'
            })
          }
        });
      } else if (this.state.truegiftlink === "") {
        await Swal.fire({
          title: 'Warning!',
          text: 'คุณไม่ได้ไส่ลิ้งค์ของขวัญ ',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
      }
    } else {
      await Swal.fire({
        title: 'Warning!',
        text: 'กำลังดำเนินการโปรดรอซักครู่',
        icon: 'warning',
        confirmButtonText: 'ตกลง'
      })
    }
  }

  confirmdeposit = async (e, num) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    if (token != null) {
      await instance.post("/api/v1/getredeempromotion", {
        userid: Username,
        System: Systems,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          this.setState({ proderedeem: res.data.message.tblpromotionredeems });
        }
      }).catch(async (err) => {});
    }

    if (num === 0) {
      if ((this.state.depositamount >= this.state.limit.min) && (this.state.depositamount <= this.state.limit.max)) {
        if (token != null) {
          Username = decoded.message.playerid;
          instance.post("/api/v1/getqrcode", {
            username: Username,
            System: Systems,
            amount: this.state.depositamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            this.setState({
              mainacc: res.data.mainacc,
              qrcode: res.data.picture
            });
          });
        }
        this.setState({ depositstate: 1 });
      } else {
        await Swal.fire({
          title: 'Warning!',
          text: 'เติมขั้นต่ำ ' + this.state.limit.min + ' บาท สูงสุด ' + this.state.limit.max + ' ',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
      }
    } else if (num === 1) {
      this.setState({ depositstate: 1 });
    } else if (num === 5) {
      document.getElementById("truemonney").click()
    } else {
      this.setState({ depositstate: 0 });
    }
  }

  redeemrank = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: 'คุณต้องการเคลม Rank หรือ ไม่?',
        showCancelButton: true,
        confirmButtonText: 'Save',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await instance.post("/api/v1/userredeemrank", {
            User_id: Username,
            rankno: index.no,
            System: Systems,
            amount: index.claimamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              this.calllisthistory(Username);
              this.checklogin();
              Swal.fire('ดำเนินการเรียบร้อย', '', 'success')
            } else {
              Swal.fire('ไม่สามารถดำเนินการได้ โปรดรอซักครู่', '', 'error')
            }
          });
        }
      })
    }
  }

  async opencliamcashout(evt, cityName) {
    var token = localStorage.getItem('auth_token');
    var decoded = jwt_decode(token);
    var Username = decoded.message.playerid;
    await instance.post("/api/v1/cliamcashout", {
      userid: Username,
      System: Systems,
    }, {
      headers: { Authorization: `Bearer ${token}` }
    }).then(async (res) => {
      if (res.data.status === 200) {
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        this.rechecklogin(Username, token);
        await Swal.fire({
          title: 'Success!',
          text: 'ทำรายการรับเงินเรียบร้อย',
          icon: 'success',
          confirmButtonText: 'ตกลง'
        })
      } else if (res.data.status === 201) {
        await Swal.fire({
          title: 'error!',
          text: 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        return false;
      } else if (res.data.status === 202) {
        await Swal.fire({
          title: 'error!',
          text: 'ไม่สามารถทำรายการได้',
          icon: 'error',
          confirmButtonText: 'ตกลง'
        })
        return false;
      }
    }).catch(async (err) => {
      if (err.response.status === 401 || err.response.status === 403) {
        localStorage.clear();
        await Swal.fire({
          title: 'Warning!',
          text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
        window.location.href = '/';
      }
    });
  }

  resetpassword = async (e, type) => {
    e.preventDefault();
    const { phoneNumber, password, oldpassword, passwordcf } = this.state;
    var token = localStorage.getItem('auth_token');
    if (password === passwordcf) {
      var Username = null;
      var decoded = null;
      if (type === 1 && token != null) {
        decoded = jwt_decode(token);
        Username = decoded.message.playerid;
        instance.post("/api/v1/resetpassword", {
          username: Username,
          oldpass: oldpassword,
          System: Systems,
          newpass: password,
          type: type
        }, {
          headers: { Authorization: `Bearer ${token}` }
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({ title: 'Success!', text: 'เปลี่ยนพาสเวิดเรียบร้อย', icon: 'Success', confirmButtonText: 'ตกลง' })
          } else if (res.data.status === 201) {
            await Swal.fire({ title: 'error!', text: 'คุณใส่รหัสเก่าผิดพลาด', icon: 'error', confirmButtonText: 'ตกลง' })
          } else if (res.data.status === 203) {
            await Swal.fire({ title: 'error!', text: 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง', icon: 'error', confirmButtonText: 'ตกลง' })
          } else if (res.data.status === 202) {
            await Swal.fire({ title: 'error!', text: 'คุณใช้พาสเวิดเดิม', icon: 'error', confirmButtonText: 'ตกลง' })
          }
        });
      } else if (type === 2 || type === 3) {
        instance.post("/api/v1/resetpassword", {
          username: phoneNumber,
          oldpass: oldpassword,
          newpass: password,
          System: Systems,
          type: type
        }).then(async (res) => {
          if (res.data.status === 200) {
            await Swal.fire({ title: 'success!', text: 'เปลี่ยนพาสเวิดเรียบร้อย', icon: 'success', confirmButtonText: 'ตกลง' })
          } else if (res.data.status === 201) {
            await Swal.fire({ title: 'error!', text: 'คุณใส่รหัสเก่าผิดพลาด', icon: 'error', confirmButtonText: 'ตกลง' })
          } else if (res.data.status === 203) {
            await Swal.fire({ title: 'error!', text: 'มีข้อผิดพลาด โปรดทำรายการอีกครั้ง', icon: 'error', confirmButtonText: 'ตกลง' })
          } else if (res.data.status === 202) {
            await Swal.fire({ title: 'error!', text: 'คุณใช้พาสเวิดเดิม', icon: 'error', confirmButtonText: 'ตกลง' })
          }
        });
      }
    } else {
      await Swal.fire({
        title: 'error!',
        text: 'คุณใส่พาสเวิดไม่ตรงกัน',
        icon: 'error',
        confirmButtonText: 'ตกลง'
      })
    }
  }

  nextstep = async (e, num) => {
    e.preventDefault();
    const { stateregis, phoneNumber, checkboxacc, fname, otpphone, accnumbertxt } = this.state

    if (num === 1) {
      const check = await this.forgetotpandregister(8);
      if (phoneNumber.length === 10 && check.checked) {
        this.setState({ stateregis: 2 });
      } else {
        if (phoneNumber.length !== 10) {
          this.setState({ stateopterror: "คุณใส่เบอร์ผิดพลาด" });
        } else if (!check.checked && check.status === 201) {
          this.setState({ stateopterror: "เบอร์นี้มีคนใช้แล้ว" });
        } else {
          this.setState({ stateopterror: "คุณทำรายการถี่เกินไป โปรดรอซักครู่" });
        }
        document.getElementById("phoneNumber").style = "border-color: #ef4444;";
        document.getElementById("checkotpforgetphonenormal").style.display = "block";
      }
    } else if (num === 2) {
      if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
        this.setState({ stateregis: 3 });
      } else {
        await Swal.fire({
          title: 'Warning!',
          text: 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน !!',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        })
      }
    } else if (num === 3) {
      this.setState({ stateregis: 4 });
    } else if (num === 5) {
      var check = await this.forgetotpandregister(7);
      if (otpphone !== "" && check.checked) {
        this.setState({ stateregis: 2 });
      } else if (otpphone === "" || otpphone.length < 4) {
        this.setState({ stateopterror: "คุณใส่ตัวเลขไม่ครบ" });
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      } else {
        this.setState({ stateopterror: "รหัสผิดพลาด" });
        document.getElementById("otpphone").style = "border-color: #ef4444;";
        document.getElementById("checkotp").style.display = "block";
      }
    } else if (num === 11) {
      this.setState({ stateregis: 1 });
    } else if (num === 22) {
      this.setState({ stateregis: 2 });
    }
  }

  forgetotpandregister = async (type) => {
    const { phoneNumber, otpphoneforget, otpphone } = this.state;
    var recheck = false;
    if (type === 4) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => { recheck = res.data.message; });
    } else if (type === 5) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphoneforget,
        System: Systems,
        type: type
      }).then(async (res) => { recheck = res.data.message; });
    } else if (type === 6) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        System: Systems,
        type: type
      }).then(async (res) => { recheck = res.data.message; });
    } else if (type === 7) {
      await instance.post("/api/v1/resetpassword", {
        username: phoneNumber,
        pin: otpphone,
        System: Systems,
        type: type
      }).then(async (res) => { recheck = res.data.message; });
    }
    return recheck
  }

  nextstepforget = async (e, num) => {
    e.preventDefault();
    const { phoneNumber, otpphoneforget } = this.state
    if (num === 1) {
      const check = await this.forgetotpandregister(4);
      if (phoneNumber.length === 10 && check.checked) {
        this.setState({ stateforget: 2 });
      } else {
        if (phoneNumber.length !== 10) {
          this.setState({ stateopterror: "คุณใส่เบอร์ผิดพลาด" });
        } else if (!check.checked && check.status === 201) {
          this.setState({ stateopterror: "ไม่มีเบอร์นี้ในระบบ" });
        } else {
          this.setState({ stateopterror: "คุณทำรายการถี่เกินไป โปรดรอซักครู่" });
        }
        document.getElementById("phoneNumberforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforgetphone").style.display = "block";
      }
    } else if (num === 2) {
      const check = await this.forgetotpandregister(5)
      if (otpphoneforget !== "" && check.checked) {
        this.setState({ stateforget: 3 });
      } else if (otpphoneforget === "" || otpphoneforget.length < 4) {
        this.setState({ stateopterror: "คุณใส่ตัวเลขไม่ครบ" });
        document.getElementById("otpphoneforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforget").style.display = "block";
      } else {
        this.setState({ stateopterror: "รหัสผิดพลาด" });
        document.getElementById("otpphoneforget").style = "border-color: #ef4444;";
        document.getElementById("checkotpforget").style.display = "block";
      }
    } else if (num === 11) {
      this.setState({ stateforget: 1 });
    }
  }

  submitwithdraw = async (e) => {
    if (parseFloat(this.state.withdrawamount) <= parseFloat(this.state.balance)) {
      if (parseFloat(this.state.withdrawamount) >= 100) {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
          var decoded = jwt_decode(token);
          var Username = decoded.message.playerid;
          instance.post("/api/v1/userwithdraw", {
            User_id: Username,
            System: Systems,
            amount: this.state.withdrawamount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              await Swal.fire({ title: 'Success!', text: 'รายการถอนเรียบร้อย', icon: 'success', confirmButtonText: 'ตกลง' })
              window.location.reload(false);
            } else if (res.data.status === 206) {
              await Swal.fire({
                title: 'Success!',
                text: 'ทำรายการสำเร็จ คุณสามารถถอนได้ไม่เกิน ' + res.data.amountturnover + " บาทเนื่องจากคุณรับโบนัส เครดิตส่วนที่เหลือเราจะทำการตัดออก",
                icon: 'success',
                confirmButtonText: 'ตกลง'
              })
            } else if (res.data.status === 203) {
              await Swal.fire({
                title: 'Error!',
                text: 'ท่านติด Turnover อีก ' + res.data.amountturnover + " บาท",
                icon: 'error',
                confirmButtonText: 'ตกลง'
              })
            }
          });
        } else {
          await Swal.fire({ title: 'error!', text: 'รายการถอนมีปัญหา โปรดติดต่อพนักงาน', icon: 'error', confirmButtonText: 'ตกลง' })
        }
      } else {
        await Swal.fire({ title: 'Warning!', text: 'ขั้นต่ำในการถอน 100 บาท', icon: 'warning', confirmButtonText: 'ตกลง' })
      }
    } else {
      await Swal.fire({ title: 'Warning!', text: 'ยอดถอนของท่านไม่เพียงพอในการถอน', icon: 'warning', confirmButtonText: 'ตกลง' })
    }
  }

  onChangex = event => {
    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === "otpphone") {
        document.getElementById("otpphone").style = "";
        document.getElementById("checkotp").style.display = "none";
      } else if (event.target.name === "phoneNumber") {
        document.getElementById("phoneNumberforget").style = "";
        document.getElementById("checkotpforgetphone").style.display = "none";
      } else if (event.target.name === "otpphoneforget") {
        document.getElementById("otpphoneforget").style = "";
        document.getElementById("checkotpforget").style.display = "none";
      }
      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      this.setState({ [nam]: val });
    }
  };

  openchangepassword = (e) => {
    e.preventDefault();
    const { changepassword } = this.state
    if (changepassword) this.setState({ changepassword: false });
    else this.setState({ changepassword: true });
  }

  cancelwithdraw = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: 'คุณต้องการยกเลิกการถอนเงินใช่ หรือ ไม่?',
        showCancelButton: true,
        confirmButtonText: 'Save',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await instance.post("/api/v1/userwithdrawcancel", {
            User_id: Username,
            tid: index.tid,
            System: Systems,
            amount: index.amount
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              this.calllisthistory(Username);
              Swal.fire('ดำเนินการเรียบร้อย', '', 'success')
            } else {
              Swal.fire('ไม่สามารถดำเนินการได้ โปรดรอซักครู่', '', 'error')
            }
          });
        }
      })
    }
  }

  cancelredeempromotion = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      Swal.fire({
        icon: 'warning',
        title: 'คุณต้องการยกเลิกการใช้โปรใช่ หรือ ไม่?',
        showCancelButton: true,
        confirmButtonText: 'Save',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await instance.post("/api/v1/usercancelpromotion", {
            User_id: Username,
            no: index.no,
            System: Systems,
          }, {
            headers: { Authorization: `Bearer ${token}` }
          }).then(async (res) => {
            if (res.data.status === 200) {
              this.checkpro(null, 999);
              Swal.fire('ดำเนินการเรียบร้อย', '', 'success')
            } else {
              Swal.fire('ไม่สามารถดำเนินการได้ โปรดรอซักครู่', '', 'error')
            }
          });
        }
      })
    }
  }

  couponredeem = async (e, index) => {
    e.preventDefault();
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await instance.post("/api/v1/usercoupon", {
        User_id: Username,
        System: Systems,
        couponkey: this.state.couponkey,
        type: 1
      }).then(async (res) => {
        if (res.data.status === 200) {
          await Swal.fire({ title: 'Success!', text: 'ดำเนินการใช้คูปองเรียบร้อย', icon: 'success', confirmButtonText: 'ตกลง' })
        } else {
          await Swal.fire({ title: 'Warning!', text: 'ไม่มี Key นี้ในระบบ', icon: 'warning', confirmButtonText: 'ตกลง' })
        }
      });
    }
  }

  async calllisthistory(userid) {
    await instance.post("/api/v1/userwithdrawlist", {
      userid: userid,
      Cat_ID: 0,
      System: Systems,
      page: 1,
      type: 1
    }).then((res) => {
      if (res.data.status === 200) {
        this.setState({ historylist: res.data.message.withdrawlist });
      }
    });
  }

  async saveclickaff(linkid) {
    await instance.post("/api/v1/saveclickaff", {
      linkid: linkid,
      System: Systems,
    }).then((res) => {
      if (res.data.status == 200) {
        var date = new Date()
        this.setState({ userrecomend: res.data.username, link: linkid });
        var username = res.data.username
        var object = { date, username }
        localStorage.setItem('aff', JSON.stringify(object))
      }
    }).catch(async (err) => {});
  }

  async componentDidMount() {
    this.setState({
      pathname: window.location.pathname.replace("/", "").trim()
    });
    const endpoint = "https://apisock.newworld.center";
    const socket = io.connect(endpoint);
    var roomid = Systems;
    socket.on('connect', function (data) {
      var obj = { roomid }
      var json = JSON.stringify(obj);
      socket.emit('new', json);
    });

    const search = window.location.href;
    var test = search.split("aff=")[1]
    if (test != undefined) {
      this.saveclickaff(test.split("&")[0]);
    }

    var params = search.split("reg=")[1]
    if (params != undefined) {
      this.setState({ userrecomend: params.split("&")[0] });
    }

    var token = localStorage.getItem('register');
    if (token != null) {
      var codev = JSON.parse(token)
      var Username = codev.username;
      this.setState({ userrecomend: Username });
    }

    var afftoken = localStorage.getItem('aff');
    if (afftoken != null) {
      var affcodev = JSON.parse(afftoken)
      this.setState({ userrecomend: affcodev.username });
    }

    await this.getpopup();
  }

  onChange = async event => {
    if (event.target !== undefined) {
      let nam;
      let val;
      if (event.target.name === undefined) {
        nam = event.name;
        val = event.value;
      } else {
        nam = event.target.name;
        val = event.target.value;
      }
      if (nam === "withdrawamount") {
        if (this.state.maxwithdrawstatus === 1) {
          this.setState({ [nam]: this.state.balance });
          await Swal.fire({ title: 'Warning!', text: 'บังคับถอนยอดทั้งหมด', icon: 'warning', confirmButtonText: 'ตกลง' })
        } else if (Number(val) <= Number(this.state.balance)) {
          this.setState({ [nam]: val });
        } else {
          await Swal.fire({ title: 'Warning!', text: 'ยอดถอนของท่านไม่เพียงพอในการถอน', icon: 'warning', confirmButtonText: 'ตกลง' })
        }
      } else {
        this.setState({ [nam]: val });
      }
    }
  };

  closemodal = async (e) => {
    if (this.state.checkboxcookie) {
      var date = new Date()
      var checked = this.state.checkboxcookie
      var object = { date, checked }
      localStorage.setItem('cookie', JSON.stringify(object))
    }
  }

  async recheckbox() {
    var checked = false;
    if (this.state.checkboxcookie) checked = false;
    else checked = true;
    this.setState({ checkboxcookie: checked });
  }

  async checklogin() {
    var token = localStorage.getItem('auth_token');
    if (token != null) {
      var cookie = localStorage.getItem('cookie');
      if (cookie != 'null' && cookie != null) {
        var persons = JSON.parse(cookie);
        if (persons.checked != null) {
          this.setState({ checkboxcookie: persons.checked });
        }
      }
      var decoded = jwt_decode(token);
      var Username = decoded.message.playerid;
      await this.rechecklogin(Username, token);
    } else {
      this.setState({ loginstate: false });
    }
  }

  redeem = (e) => {
    e.preventDefault();
    if (!this.state.loginstate) {
      var title = 'error'
      var text = ' คุณไม่ได้ทำการ Login'
      var object = { title, text }
      this.modalerror(object);
    } else {
      window.location.href = '/promotions';
    }
  }

  redeemlink = (e, link) => {
    e.preventDefault();
    if (!this.state.loginstate) {
      var title = 'error'
      var text = ' คุณไม่ได้ทำการ Login'
      var object = { title, text }
      this.modalerror(object);
    } else {
      window.location.href = link;
    }
  }

  async modalerror(object) {
    await Swal.fire({
      title: object.title + "!",
      text: object.text,
      icon: object.title,
      confirmButtonText: 'ตกลง'
    })
  }

  validatergisterForm = async (e) => {
    e.preventDefault();
    const { phoneNumber, fname, password, passwordcf, checkboxacc, accnumbertxt } = this.state;
    if (password.length < 6) {
      this.modalerror({ title: 'Error!', text: 'Password คุณไม่ครบ 6 ตัวโปรดตรวจสอบ' });
    } else if (phoneNumber === "") {
      this.modalerror({ title: 'Error!', text: 'คุณไม่ทำการใส่ เบอร์โทรศัพท์' });
    } else if (accnumbertxt === "") {
      this.modalerror({ title: 'Error!', text: 'คุณไม่ทำการใส่เลขบัญชีธนาคาร' });
    } else if (fname === "") {
      this.modalerror({ title: 'Error!', text: 'คุณไม่ทำการใส่ ชื่อ-นามสกุล' });
    } else if (checkboxacc === 0) {
      this.modalerror({ title: 'Error!', text: 'คุณยังไม่ได้เลือกธนาคาร' });
    } else if (password !== passwordcf) {
      this.modalerror({ title: 'Error!', text: 'คุณไส่พาสเวิดไม่ตรงกัน' });
    } else {
      instance.post("/api/v1/register", {
        User_id: phoneNumber,
        name: fname,
        password: password,
        accbank: checkboxacc,
        accno: accnumbertxt,
        System: Systems,
        Useradvise: this.state.userrecomend
      }).then(async (res) => {
        if (res.data.status === 200) {
          await Swal.fire({ title: 'Success!', text: 'ทำการสมัครเรียบร้อยโปรด Log in อีกครั้ง', icon: 'success', confirmButtonText: 'ตกลง' })
          window.location.href = '/';
        } else if (res.data.status === 202) {
          this.setState({ errorstatus: 1, errortext: 'Username นี้ทำการสมัครไปแล้ว' });
        } else {
          this.setState({ errorstatus: 1, errortext: 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง' });
        }
      });
    }
  }

  rechecklogin = async (Username, token) => {
    try {
      const space = window.location.host
      var userhash = md5(Username);
      const linkaff = "https://" + space + "/register?reg=" + userhash;
      await instance.post("/api/v1/checkpoint", {
        userid: Username,
        System: Systems,
        Update: userhash,
        Function: 'rechecklogin-App.js'
      }, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(async (res) => {
        if (res.data.status === 200) {
          this.calllisthistory(Username);
          localStorage.setItem('auth_token', res.data.token)
          var rankall = res.data.tblrankall;
          const found = rankall.find(obj => obj.checked === 1);
          this.setState({
            tblrankall: res.data.tblrankall,
            linkaff: linkaff,
            buttoncliam: (found === undefined) ? true : false,
            tblnextrank: res.data.tblnextrank,
            rankpic: (!res.data.tblrank?.image) ? "https://betner.co/build/rank/1.jpeg" : (!res.data.tblrank?.picrack) ? "https://betner.co/build/rank/" + res.data.tblrank.image : res.data.tblrank.picrack,
            rankname: res.data.tblrank?.name,
            rankob: res.data.tblrank,
            tblprofile: res.data.message,
            rankpoint: res.data.rankpoint,
            accnumber: res.data.message.accnumber,
            userid: res.data.message.member_id,
            username: res.data.message.playerid,
            fullname: res.data.message.firstname,
            point: res.data.message.Point,
            balance: res.data.databalance,
            loginstate: true,
          });
        } else if (res.data.status === 401) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      }).catch(async (err) => {
        if (err.response.status === 401 || err.response.status === 403) {
          localStorage.clear();
          await Swal.fire({
            title: 'Warning!',
            text: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            confirmButtonText: 'ตกลง'
          })
          window.location.href = '/';
        }
      });
    } catch (ex) {}
  }

  render() {
    const pathname = this.state.pathname
    const { loginstate, cashoutSet, stateopterror, changepassword, username, balance, accnumber, fullname, mainacc, limit, rankob, rankpoint, tblnextrank, userrecomend, linkaff, tblprofile, proderedeem, proderedeemlist, prodetail } = this.state

    var accnumberx;
    if (accnumber != null) {
      accnumberx = accnumber[0];
    }

    return (
      <>
        <Routes>
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/withdraw" element={<Withdraw />} />
          <Route path="/rebate" element={<Rebate />} />
          <Route path="/statement" element={<Statement />} />
          <Route path="/changepassword" element={<Changepassword />} />
          <Route path="/daily-mission" element={<DailyMission />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/*" element={<Main />} />
        </Routes>
        <ToastContainer />
      </>
    );
  }
}

export default App;
